import { Stack } from '@fluentui/react';
import { FormHookTextField } from 'common/components/FormHooksFields';
import { useStyles } from './index.styles';

interface BasicFormProps {
  isUpdatable: boolean;
}
export const BasicForm: React.FC<BasicFormProps> = ({ isUpdatable }) => {
  const styles = useStyles();

  return (
    <Stack className={styles.container} tokens={{ childrenGap: 10 }}>
      <Stack horizontal tokens={{ childrenGap: 20 }} verticalAlign="center">
        <Stack className={styles.fieldContainer}>
          <FormHookTextField
            label="Name"
            name="name"
            required
            disabled={!isUpdatable}
          />
        </Stack>
      </Stack>
      <Stack>
        <Stack className={styles.fieldContainer}>
          <FormHookTextField
            label="Description"
            name="description"
            multiline
            rows={3}
            disabled={!isUpdatable}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
